import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/Export";

export const Mikro = {
  ExportSaleToMikro: (options) =>
    GENERATE_URL(`${PREFIX_URL}/Mikro/ExportSaleToMikro`, options),
  ExportCustomerToMikro: (options) =>
    GENERATE_URL(`${PREFIX_URL}/Mikro/ExportCustomerToMikro`, options),
};

export default {
  Mikro,
};
